import * as auth from './auth'
import * as users from './users'
import * as courses from './courses'
import * as lessons from './lessons'
import * as banners from './banners'
import * as dashboard from './dashboard'

export default { auth, users, courses, lessons, banners, dashboard }
